var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 246 136"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.67 126.637a5.179 5.179 0 0 0-1.407 2.993 5.16 5.16 0 0 0 .625 3.25c.555 1.021 1.367 1.764 2.418 2.25 1.05.486 2.14.614 3.27.377l116.272-24.133 116.272 24.133c1.13.237 2.22.109 3.27-.377a5.17 5.17 0 0 0 2.419-2.25 5.163 5.163 0 0 0 .624-3.25 5.248 5.248 0 0 0-1.407-2.993L126.683 2.317a5.155 5.155 0 0 0-1.754-1.229 5.203 5.203 0 0 0-4.172 0 5.253 5.253 0 0 0-1.754 1.23L1.671 126.636Z"
  })));
};
export default SvgLogo;